import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';

import App from './App';

import './index.scss';

ReactDOM.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
  document.getElementById('root')
);

// Marca los títulos visibles una vez para disparar el click sin depender del scroll.
const setupPointerClickOnce = () => {
  if (!('IntersectionObserver' in window) || !('MutationObserver' in window)) {
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('click-fired');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  const isVisibleEnough = (el) => {
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const visibleHeight = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0));
    return rect.height > 0 && (visibleHeight / rect.height) >= 0.2;
  };

  const watchTargets = () => {
    document.querySelectorAll('.title strong:not([data-click-observed])')
      .forEach((el) => {
        el.dataset.clickObserved = 'true';
        observer.observe(el);
        if (isVisibleEnough(el)) {
          el.classList.add('click-fired');
          observer.unobserve(el);
        }
      });
  };

  const mo = new MutationObserver(watchTargets);
  mo.observe(document.body, { childList: true, subtree: true });

  watchTargets();
};

// Espera un tick para asegurar que el DOM inicial esté montado
window.requestAnimationFrame(setupPointerClickOnce);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
